function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Link } from "react-router-dom";
import { PageHeader, Switcher, Empty } from "../../components/analytics-kit";
import { emailViews } from "../email-automation/index";

/** Honest empty state for a workspace the API refuses (403 outreach_not_enabled) or the registry has not flagged. */
export function NotEnabled({
  title = "Outreach"
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: "territory-view wa-view ec-view or-view"
  }, /*#__PURE__*/React.createElement(PageHeader, {
    title: title,
    subtitle: "Cold B2B email programs from your own sending domains and mailboxes"
  }), /*#__PURE__*/React.createElement(Switcher, {
    items: emailViews(),
    ariaLabel: "Email views"
  }), /*#__PURE__*/React.createElement("div", {
    className: "wa-grid"
  }, /*#__PURE__*/React.createElement("section", {
    className: "wa-card c12"
  }, /*#__PURE__*/React.createElement(Empty, null, /*#__PURE__*/React.createElement("b", null, "Outreach is not enabled for this workspace."), /*#__PURE__*/React.createElement("br", null), "Outreach runs cold B2B sequences from dedicated domains and warmed mailboxes. It is switched on per workspace; ask Plunk to enable it. Your ", /*#__PURE__*/React.createElement(Link, {
    to: "/Email/campaigns"
  }, "email campaigns"), " and ", /*#__PURE__*/React.createElement(Link, {
    to: "/Email/journeys"
  }, "journeys"), " are not affected."))));
}

/** The Outreach sub-views as header links (the Email switcher above stays the section's tabs). */
export function OutreachLinks({
  current,
  replies
}) {
  const items = [["programs", "/Email/outreach", "Outreach"], ["replies", "/Email/outreach/replies", replies ? `Outreach replies · ${replies}` : "Outreach replies"], ["infrastructure", "/Email/senders/outreach", "Outreach mailboxes"]];
  return /*#__PURE__*/React.createElement("span", {
    className: "or-links"
  }, items.map(([k, to, label]) => k === current ? /*#__PURE__*/React.createElement("span", {
    key: k,
    className: "wa-chip on"
  }, label) : /*#__PURE__*/React.createElement(Link, {
    key: k,
    to: to,
    className: "wa-chip"
  }, label)));
}

/** One review check line (✓ / × / !). */
export function Check({
  state,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: `ec-check ${state}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "m"
  }, state === "ok" ? "✓" : state === "bad" ? "×" : "!"), /*#__PURE__*/React.createElement("span", null, children));
}

/** Lint findings list, verbatim from GET programs/{id}/lint. */
export function Findings({
  findings,
  onStep
}) {
  if (!findings || !findings.length) return null;
  return /*#__PURE__*/React.createElement("ul", {
    className: "ec-findings"
  }, findings.map((f, i) => /*#__PURE__*/React.createElement("li", {
    key: i,
    className: f.severity
  }, /*#__PURE__*/React.createElement("span", {
    className: `wa-pill ${f.severity === "error" ? "danger" : "warning"}`
  }, f.severity), " ", /*#__PURE__*/React.createElement("code", null, f.code), " ", f.message, f.stepOrdinal && onStep ? /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement("a", {
    onClick: () => onStep(f.stepOrdinal)
  }, "step ", f.stepOrdinal)) : null)));
}

// ---------------------------------------------------------------- 2026-10-09 Outreach redesign (orp-*): shared by index.jsx + detail.jsx

/** Days a new mailbox ramps before full pace (the WarmupRamp table: cold sends from day 8, full pace from day 22). */
/** "Plain text, counts link clicks" / "Formatted email, counts clicks and opens" / "..., no tracking". */
export function trackingText(st) {
  const plain = (st || {}).plainText !== false;
  const clicks = !!(st || {}).trackClicks,
    opens = !plain && !!(st || {}).trackOpens;
  const t = clicks && opens ? "counts clicks and opens" : clicks ? "counts link clicks, no open tracking" : opens ? "counts opens, not clicks" : "no click or open tracking";
  return `${plain ? "Plain text" : "Formatted email"}, ${t}`;
}
/** What the program counts beyond replies: {clicks, opens} (opens need a formatted email, the pixel is an image). */
export function orpTracked(settings) {
  const st = settings || {};
  return {
    clicks: !!st.trackClicks,
    opens: !!st.trackOpens && st.plainText === false
  };
}

/** "12 opened · 3 clicked" for an Outreach card; "" when nothing is tracked or counted yet. */
export function orpEngagement(settings, stats) {
  const t = orpTracked(settings),
    s = stats || {};
  const parts = [];
  if (t.opens || Number(s.opens)) parts.push(`${orpN(s.opens)} opened`);
  if (t.clicks || Number(s.clicks)) parts.push(`${orpN(s.clicks)} clicked`);
  return parts.join(" · ");
}
export const ORP_WARM_DAYS = 21;
export const ORP_FIRST_SEND_DAY = 8;

/** Mirror of WarmupRamp.ColdCap / EffectiveColdCap (Service.Outreach) for mailboxes that arrive without capToday. */
export function orpColdCap(warmDay, dailyCap, date) {
  const d = date || new Date();
  const dow = d.getDay();
  if (dow === 0 || dow === 6) return 0;
  const w = Number(warmDay) || 0;
  const ramp = w <= 7 ? 0 : w <= 14 ? 5 : w <= 21 ? 15 : 30;
  const cap = Number(dailyCap) || 0;
  return cap > 0 ? Math.min(ramp, cap) : ramp;
}
export function orpFullCap(dailyCap) {
  const c = Number(dailyCap) || 0;
  return c > 0 ? Math.min(30, c) : 30;
}
const orpN = v => (Number(v) || 0).toLocaleString("en-US");
export const orpPlural = (n, one, many) => `${orpN(n)} ${Number(n) === 1 ? one : many || one + "s"}`;

/** "Oct 15" for a date N calendar days from today. */
export function orpDateIn(days) {
  const d = new Date(Date.now() + Math.max(0, Number(days) || 0) * 86400000);
  return d.toLocaleDateString([], {
    month: "short",
    day: "numeric"
  });
}

/**
 * One summary over a list of mailboxes: the GET infrastructure MailboxHealth rows (mailboxId, capToday) or the
 * program detail's OutreachMailbox rows (id, dailyCap). Disabled mailboxes are left out of every count.
 */
export function orpMailboxSummary(list) {
  const all = (list || []).filter(m => m && m.status !== "disabled");
  const by = s => all.filter(m => m.status === s);
  const warming = by("warming"),
    active = by("active"),
    paused = by("paused"),
    provisioning = by("provisioning");
  const sending = all.filter(m => m.status === "warming" || m.status === "active");
  const days = sending.map(m => Number(m.warmDay) || 0);
  const warmDays = warming.map(m => Number(m.warmDay) || 0);
  const cap = m => m.capToday != null ? Number(m.capToday) || 0 : orpColdCap(m.warmDay, m.dailyCap);
  const minDay = days.length ? Math.min(...days) : 0;
  const maxDay = days.length ? Math.max(...days) : 0;
  const minWarm = warmDays.length ? Math.min(...warmDays) : 0;
  const maxWarm = warmDays.length ? Math.max(...warmDays) : 0;
  const now = new Date();
  return {
    total: all.length,
    warming: warming.length,
    active: active.length,
    paused: paused.length,
    provisioning: provisioning.length,
    pausedList: paused,
    minDay,
    maxDay,
    minWarm,
    maxWarm,
    capNow: sending.reduce((a, m) => a + cap(m), 0),
    capFull: sending.reduce((a, m) => a + orpFullCap(m.dailyCap), 0),
    sentToday: all.reduce((a, m) => a + (Number(m.sentToday) || 0), 0),
    weekend: now.getDay() === 0 || now.getDay() === 6,
    // calendar days until the slowest warming mailbox may send outreach (day 8) and until all reach full pace (day 22)
    daysToFirstSend: warming.length ? Math.max(0, ORP_FIRST_SEND_DAY - minWarm) : 0,
    daysToFullPace: days.length ? Math.max(0, ORP_WARM_DAYS + 1 - minDay) : 0,
    problems: all.filter(m => (m.findings || []).some(f => /threshold/.test(String(f))))
  };
}

/** "day 3 of 21" or "days 3 to 9 of 21". */
export function orpDayRange(a, b) {
  const x = Math.min(a, ORP_WARM_DAYS),
    y = Math.min(b, ORP_WARM_DAYS);
  return x === y ? `day ${x} of ${ORP_WARM_DAYS}` : `days ${x} to ${y} of ${ORP_WARM_DAYS}`;
}

/** Program status → list filter bucket and plain words. */
export function orpBucket(status) {
  switch (status) {
    case "Running":
    case "Paused":
      return "sending";
    case "Approved":
      return "ready";
    case "Completed":
    case "Canceled":
      return "finished";
    default:
      return "drafts";
  }
}
export function orpStatusWord(p) {
  const s = (p || {}).status;
  if (s === "Draft" && p.reviewStatus === "Rejected") return "Sent back";
  return {
    Draft: "Draft",
    InReview: "Waiting for approval",
    Approved: "Ready to start",
    Running: "Sending",
    Paused: "Paused",
    Completed: "Finished",
    Canceled: "Canceled"
  }[s] || s || "Draft";
}
export function OrpStatus({
  program
}) {
  const s = (program || {}).status;
  const tone = s === "Running" ? "running" : s === "Approved" ? "ready" : s === "Paused" || s === "InReview" || s === "Draft" && program.reviewStatus === "Rejected" ? "paused" : s === "Canceled" ? "failed" : "draft";
  return /*#__PURE__*/React.createElement("span", {
    className: `ejl-status orp-status ${tone}`
  }, orpStatusWord(program));
}

/** Send window → "weekdays 8 AM to 5 PM their time". */
const ORP_DAY = ["", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
function orpClock(t) {
  const m = /^(\d{1,2}):(\d{2})/.exec(String(t || ""));
  if (!m) return t || "";
  const h = Number(m[1]),
    mm = m[2];
  const ap = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return mm === "00" ? `${h12} ${ap}` : `${h12}:${mm} ${ap}`;
}
export function orpWindowPhrase(w) {
  const win = w || {};
  const days = Array.from(new Set((win.days && win.days.length ? win.days : [1, 2, 3, 4, 5]).map(Number))).sort();
  let d;
  if (days.length === 7) d = "every day";else if (days.join() === "1,2,3,4,5") d = "weekdays";else if (days.join() === "6,7") d = "weekends";else d = days.map(x => ORP_DAY[x]).join(", ");
  const tz = !win.tz || win.tz === "recipient" ? "their time" : String(win.tz).replace(/^.*\//, "").replace(/_/g, " ") + " time";
  return `${d} ${orpClock(win.start || "08:00")} to ${orpClock(win.end || "17:00")} ${tz}`;
}

/** Template parts still to replace ([[double brackets]]) in an email step, its subject and its variants. */
const ORP_PLACEHOLDER = /\[\[[^\]]+\]\]/g;
export function orpPlaceholders(step) {
  const s = step || {};
  let vs = s.variants;
  if (!vs && s.variantsJson) {
    try {
      vs = typeof s.variantsJson === "string" ? JSON.parse(s.variantsJson) : s.variantsJson;
    } catch (e) {
      vs = [];
    }
  }
  const text = [s.subject, s.bodyText, s.designJson].concat((vs || []).map(v => `${v.subject || ""} ${v.bodyText || ""} ${v.designJson || ""}`)).join(" ");
  return Array.from(new Set(text.match(ORP_PLACEHOLDER) || []));
}

/** "{{first_name|there}}" → "{first_name}" for previews. */
export function orpPrettyMerge(t) {
  return String(t || "").replace(/\{\{\s*([a-z0-9_]+)(\|[^}]*)?\s*\}\}/gi, "{$1}");
}

/** A one-line preview of an email step: its plain text, else the text inside the editor design. */
export function orpPreview(step, max = 150) {
  const s = step || {};
  let t = String(s.bodyText || "");
  if (!t.trim() && s.designJson) {
    const parts = [];
    String(s.designJson).replace(/"(?:text|html|content|body)"\s*:\s*"((?:[^"\\]|\\.)*)"/g, (m, v) => {
      parts.push(v.replace(/\\n/g, " ").replace(/\\"/g, "\""));
      return m;
    });
    t = parts.join(" ");
  }
  t = orpPrettyMerge(t.replace(/<[^>]+>/g, " ").replace(/&nbsp;/g, " ").replace(/\s+/g, " ").trim());
  return t.length > max ? t.slice(0, max).replace(/\s+\S*$/, "") + "..." : t;
}

/** Wait step → "Wait 3 days" / "Wait 3 weekdays". */
export function orpWaitText(st) {
  const n = Number(st.waitDays) || 0;
  return `Wait ${orpN(n)} ${st.businessDays ? n === 1 ? "weekday" : "weekdays" : n === 1 ? "day" : "days"}`;
}

/** ··· menu (same look as the Journeys cards): items [{label, run, danger, confirm, confirmLabel, title}]. */
export class OrpMenu extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "outside", e => {
      if (this.state.open && this.ref.current && !this.ref.current.contains(e.target)) this.setState({
        open: false,
        confirm: null
      });
    });
    _defineProperty(this, "esc", e => {
      if (e.key === "Escape" && this.state.open) this.setState({
        open: false,
        confirm: null
      });
    });
    this.state = {
      open: false,
      confirm: null
    };
    this.ref = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    document.addEventListener("mousedown", this.outside);
    document.addEventListener("keydown", this.esc);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.outside);
    document.removeEventListener("keydown", this.esc);
  }
  render() {
    const {
      items,
      disabled,
      large
    } = this.props;
    const {
      open,
      confirm
    } = this.state;
    if (!items || !items.length) return null;
    return /*#__PURE__*/React.createElement("span", {
      className: "ejl-menu orp-menu",
      ref: this.ref,
      onClick: e => e.stopPropagation(),
      onKeyDown: e => e.stopPropagation()
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: `ejl-more${large ? " lg" : ""}`,
      "aria-label": "More actions",
      "aria-haspopup": "menu",
      "aria-expanded": open,
      disabled: disabled,
      onClick: () => this.setState({
        open: !open,
        confirm: null
      })
    }, "\xB7\xB7\xB7"), open ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-menu-list",
      role: "menu"
    }, confirm ? /*#__PURE__*/React.createElement("div", {
      className: "ejl-menu-confirm"
    }, /*#__PURE__*/React.createElement("span", null, confirm.confirm), /*#__PURE__*/React.createElement("span", {
      className: "row"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: () => this.setState({
        confirm: null
      })
    }, "Keep"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "danger",
      onClick: () => {
        this.setState({
          open: false,
          confirm: null
        });
        confirm.run();
      }
    }, confirm.confirmLabel || "Yes"))) : items.map(it => /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      key: it.label,
      className: it.danger ? "danger" : "",
      title: it.title || undefined,
      onClick: () => {
        if (it.confirm) {
          this.setState({
            confirm: it
          });
          return;
        }
        this.setState({
          open: false
        });
        it.run();
      }
    }, it.label))) : null);
  }
}